import { useEffect } from 'react';
/**
 * Add an event listener to the window object for the lifecycle of a component. Cleans up when a value in deps
 * list changes or the component unmounts.
 *
 * For example:
 * ```typescript
 * useWindowEventListener(resizeEvent => {
 *     // Respond to resizeEvent here
 * }, 'resize');
 * ```
 */
export const useWindowEventListener = (eventListener, eventType, deps) => {
    useEffect(() => {
        window.addEventListener(eventType, eventListener);
        return () => window.removeEventListener(eventType, eventListener);
    }, [eventType, eventListener, deps]);
};
//# sourceMappingURL=use-window-event-listener.js.map